"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AspectRatiosStub_1 = require("./AspectRatiosStub");
const CompositionsStub_1 = require("./CompositionsStub");
const ContentTypesStub_1 = require("./ContentTypesStub");
const HeightsStub_1 = require("./HeightsStub");
const IndustriesStub_1 = require("./IndustriesStub");
const PlacementsStub_1 = require("./PlacementsStub");
const ScopesStub_1 = require("./ScopesStub");
const SearchQueryStub_1 = require("./SearchQueryStub");
const TagsStub_1 = require("./TagsStub");
const WidthsStub_1 = require("./WidthsStub");
const CreativeStub_1 = require("./CreativeStub");
const FacetStub_1 = require("./FacetStub");
exports.Generator = {
    generateAspectRatioEntity: AspectRatiosStub_1.generateAspectRatioEntity,
    generateCompositionEntity: CompositionsStub_1.generateCompositionEntity,
    generateContentTypeEntity: ContentTypesStub_1.generateContentTypeEntity,
    generateHeightEntity: HeightsStub_1.generateHeightEntity,
    generateIndustryEntity: IndustriesStub_1.generateIndustryEntity,
    generatePlacementEntity: PlacementsStub_1.generatePlacementEntity,
    generateScopeEntity: ScopesStub_1.generateScopeEntity,
    generateSearchQuery: SearchQueryStub_1.generateSearchQuery,
    generateTagEntity: TagsStub_1.generateTagEntity,
    generateWidthEntity: WidthsStub_1.generateWidthEntity,
    generateCreativeEntity: CreativeStub_1.generateCreativeEntity,
    generateFacetEntity: FacetStub_1.generateFacetEntity,
    generateAllFacetEntity: FacetStub_1.generateAllFacetEntity,
};
